import "@babel/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { unregister } from './registerServiceWorker';
import { HashRouter } from 'react-router-dom';
import './assets/base.scss';
import Main from './Layout/Main';
import configureStore from './config/configureStore';
import { Provider } from 'react-redux';

import "@fortawesome/fontawesome-free/css/all.min.css";
import '@fortawesome/fontawesome-pro/css/all.min.css';

const store = configureStore();
const rootElement = document.getElementById('root');
const renderApp = Component => {
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Component />
      </HashRouter>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept('./Layout/Main', () => {
    const NextApp = require('./Layout/Main').default;
    renderApp(NextApp);
  });
}
unregister();


